import { Card, Spin, Typography } from "antd";
import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getEmailVerification, verifyEmail } from "../api/allauth";
import styles from "./Accounts.module.css";

const { Title, Text } = Typography;

export const VerifyEmailPage = () => {
    const { key } = useParams();
    const navigate = useNavigate();
    const [status, setStatus] = useState("loading"); // "loading" | "success" | "error"
    const [email, setEmail] = useState(null);
    const [errorMessage, setErrorMessage] = useState("");
    const didRun = useRef(false);

    useEffect(() => {
        if (didRun.current) return; // prevent second StrictMode run
        didRun.current = true;

        if (!key) return;

        const decodedKey = decodeURIComponent(key);

        const confirmEmail = async () => {
            setStatus("loading");
            const start = Date.now();

            try {
                const verification = await getEmailVerification(decodedKey);
                setEmail(verification.data?.email || null);

                const resp = await verifyEmail(decodedKey);

                const elapsed = Date.now() - start;
                const delay = Math.max(0, 500 - elapsed); // at least 500ms spinner
                await new Promise((res) => setTimeout(res, delay));

                if ([200, 401].includes(resp?.status)) {
                    setStatus("success");
                    setTimeout(() => navigate("/"), 1500);
                } else {
                    setStatus("error");
                    const msg = resp?.errors?.[0]?.message || "Email verification failed.";
                    setErrorMessage(msg);
                }
            } catch (err) {
                setStatus("error");
                setErrorMessage("Unable to confirm email. Please, try again later or contact support.");
            }
        };

        confirmEmail();
    }, [key, navigate]);


    const renderBody = () => {
        switch (status) {
            case "loading":
                return <Spin tip="Verifying your email…" />;
            case "success":
                return (
                    <Text type="success">
                        Successifully confirmed {email ? `${email}` : ""}. <br />Redirecting…
                    </Text>
                );
            case "error":
                return <Text type="danger">{errorMessage}</Text>;
            default:
                return null;
        }
    };

    return (
        <Card className={styles.card} style={{ maxWidth: 480, textAlign: "center" }}>
            <img src="/w5n-logo.svg" alt="Logo" className={styles.logo} style={{ marginBottom: 24 }} />
            <Title level={3}>Confirm Email Address</Title>
            <div style={{ marginTop: 16 }}>{renderBody()}</div>
        </Card>
    );
};

export default VerifyEmailPage;
